import React from 'react'
import CreateDepartmentForm from 'src/app/Departments/CreateDepartmentForm'
import Popup from 'src/components/Popup/Popup'
import { css } from 'styled-components'

interface CreateDepartmentFormProps {
  closeCreateDepartmentForm: () => void
}
const CreateDepartmentPopup: React.FC<CreateDepartmentFormProps> = (props) => {
  return (
    <Popup
      css={css`
        z-index: 10;
        display: flex;
        flex-direction: column;
        position: relative;
        box-shadow: none;
      `}
      onClose={props.closeCreateDepartmentForm}
    >
      <CreateDepartmentForm
        closeCreateDepartmentForm={props.closeCreateDepartmentForm}
      />
    </Popup>
  )
}

export default CreateDepartmentPopup
